<template>
  <div :class="{ 'rounded overflow-hidden': !compactMode }">
    <div
      v-if="!compactMode"
      class="flex flex-row justify-between items-center p-2 cursor-pointer select-none text-gray-900 group/parent"
      @click="useAppSidebarStore().toggleExpand(item.id)"
    >
      <span class="group-hover/parent:text-primary tracking-tight">
        {{ item.title }}
      </span>
      <AppIcon
        v-if="!isExpanded"
        icon="fa-light fa-square-chevron-down"
        class="h-4 w-4 group-hover/parent:text-primary"
      />
      <AppIcon
        v-else
        icon="fa-light fa-square-chevron-up"
        class="h-4 w-4 group-hover/parent:text-primary"
      />
    </div>
    <Transition>
      <div v-if="isExpanded">
        <SidebarChildItem
          v-for="childItem in item.children"
          :key="childItem.id"
          :item="childItem"
        />
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import { Menu } from "@q-food/q-food";
import { useAppSidebarStore } from "~/stores/AppSidebar";

const props = defineProps<{
  item: Menu;
}>();

const { expandedItems, compactMode } = storeToRefs(useAppSidebarStore());
const isExpanded = computed(() => expandedItems.value.has(props.item.id));
</script>

<style scoped>
.v-enter-active {
  transition: opacity 0.1s linear;
}

.v-enter-from {
  opacity: 0;
}
</style>
